var BlsEventMainProductShopify = {
    init: function() {
        this.eventMediaGalleryProduct()
    },
    eventMediaGalleryProduct: function() {
        const e = document.querySelector(".bls__swiper-gallery-thumbnails"),
            t = document.querySelector(".bls__swiper-gallery");
        if (e)
            if (e.classList.contains("bls__swiper-vertical")) var r = new Swiper(".bls__swiper-gallery-thumbnails.bls__swiper-vertical", {
                spaceBetween: 10,
                slidesPerView: 8,
                freeMode: !0,
                direction: "vertical",
                watchSlidesProgress: !0, 
                loop:true,
                navigation: {
                    nextEl: ".swiper-next-arrow",
                    prevEl: ".swiper-prev-arrow"
                }
            });
            else r = new Swiper(".bls__swiper-gallery-thumbnails", {
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: !0,
                watchSlidesProgress: !0,
                navigation: {
                    nextEl: ".swiper-next",
                    prevEl: ".swiper-prev"
                }
            });
        if (t)
            if (r) var o = new Swiper(".bls__swiper-gallery", {
                loop: !1,
                speed: 600,
                navigation: {
                    nextEl: ".swiper-next",
                    prevEl: ".swiper-prev"
                },
                thumbs: {
                    swiper: r
                }
            });
            else {
                const e = "true" === t.dataset.autoplay,
                    r = t?.dataset.mobile,
                    i = t?.dataset.spacing,
                    a = t?.dataset.sectionId;
                o = new Swiper(".bls__swiper-gallery", {
                    slidesPerView: r,
                    spaceBetween: Number(i),
                    autoplay: e,
                    speed: 600,
                    loop: !1,
                    grid: {
                        rows: a
                    },
                    navigation: {
                        nextEl: ".swiper-next",
                        prevEl: ".swiper-prev"
                    },
                    pagination: {
                        clickable: !0,
                        el: ".swiper-pagination"
                    }
                })
            } const i = document.querySelector(".bls__swiper-gallery-thumbnails-mobile"),
            a = document.querySelector(".bls__swiper-gallery-mobile");
        if (i && a) var n = new Swiper(".bls__swiper-gallery-thumbnails-mobile", {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: !0,
            watchSlidesProgress: !0,
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev"
            }
        });
        if (n) var c = new Swiper(".bls__swiper-gallery-mobile", {
            spaceBetween: 0,
            speed: 600,
            loop: !1,
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev"
            },
            thumbs: {
                swiper: n
            }
        });
        else c = new Swiper(".bls__swiper-gallery-mobile", {
            slidesPerView: 1,
            longSwipesMs: 600,
            spaceBetween: 0,
            autoplay: !1,
            loop: !1,
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev"
            },
            pagination: {
                clickable: !0,
                el: ".swiper-pagination"
            }
        });
        var s = [],
            l = [],
            d = [],
            u = [],
            p = [];
        document.querySelectorAll(".product__media-desktop [data-group]").forEach((e => {
            s.push(e)
        })), document.querySelectorAll(".product__media-desktop [data-group-thumb]").forEach((e => {
            l.push(e)
        })), document.querySelectorAll(".product__media-mobile [data-group]").forEach((e => {
            d.push(e)
        })), document.querySelectorAll(".product__media-mobile [data-group-thumb]").forEach((e => {
            u.push(e)
        })), document.querySelectorAll(".gallery-img[data-alt]").forEach((e => {
            p.push(e)
        }));
        var m, h = document.querySelector("[data-variant-selected]")?.getAttribute("data-variant-selected");
        if (document.querySelectorAll("[data-alt]").forEach((e => {
                var t = e.getAttribute("data-alt");
                h == t && document.querySelector("[data-variant-group]")?.setAttribute("data-variant-group", !0), m = document.querySelector("[data-variant-group]")?.getAttribute("data-variant-group")
            })), "true" === m) {
            let e = [],
                t = [],
                i = [],
                a = [];
            l.forEach((t => {
                t.getAttribute("data-alt") === h && e.push(t)
            })), s.forEach((e => {
                e.getAttribute("data-alt") === h && t.push(e)
            })), u.forEach((e => {
                e.getAttribute("data-alt") === h && i.push(e)
            })), d.forEach((e => {
                e.getAttribute("data-alt") === h && a.push(e)
            })), p.forEach((e => {
                e.getAttribute("data-alt") === h ? (e.classList.add("media-active"), e.classList.remove("media-hidden")) : (e.classList.add("media-hidden"), e.classList.remove("media-active"))
            })), o && (o.removeAllSlides(), o.appendSlide(e), o.slideToLoop(0), e.forEach((e => {
                e.classList.add("media-active")
            })), o.update()), r && (r.removeAllSlides(), r.appendSlide(t), r.slideToLoop(0), t.forEach((e => {
                e.classList.add("media-active")
            })), r.update()), c && (c.removeAllSlides(), c.appendSlide(i), c.slideToLoop(0), i.forEach((e => {
                e.classList.add("media-active")
            })), c.update()), n && (n.removeAllSlides(), n.appendSlide(a), n.slideToLoop(0), a.forEach((e => {
                e.classList.add("media-active")
            })), n.update())
        }
        document.querySelectorAll(".bls__product-details-infor .bls__option-swatch").forEach((e => {
            e.addEventListener("click", (e => {
                const t = e.currentTarget;
                var i = t.closest("variant-selects").querySelector(".bls__product-color-swatches.active")?.getAttribute("data-filter-color"),
                    a = t.closest(".bls__template-product").querySelector("[data-variant-group]")?.getAttribute("data-variant-group");
                let m, h = [],
                    y = [],
                    b = [],
                    v = [];
                "true" === a && (l.forEach((e => {
                    m = e.getAttribute("data-alt"), m === i && h.push(e)
                })), s.forEach((e => {
                    m = e.getAttribute("data-alt"), m === i && ("0" === e.dataset.swiperSlideIndex && e.classList.add("swiper-slide-thumb-active"), y.push(e))
                })), u.forEach((e => {
                    m = e.getAttribute("data-alt"), m === i && b.push(e)
                })), d.forEach((e => {
                    m = e.getAttribute("data-alt"), m === i && v.push(e)
                })), p.forEach((e => {
                    m = e.getAttribute("data-alt"), m === i ? (e.classList.add("media-active"), e.classList.remove("media-hidden")) : (e.classList.add("media-hidden"), e.classList.remove("media-active"))
                })), o && (o.removeAllSlides(), o.appendSlide(h), o.slideTo(0), h.forEach((e => {
                    e.classList.add("media-active")
                })), o.update()), r && (r.removeAllSlides(), r.appendSlide(y), r.slideTo(0), y.forEach((e => {
                    e.classList.add("media-active")
                })), r.update()), c && (c.removeAllSlides(), c.appendSlide(b), c.slideTo(0), b.forEach((e => {
                    e.classList.add("media-active")
                })), c.update()), n && (n.removeAllSlides(), n.appendSlide(v), n.slideTo(0), v.forEach((e => {
                    e.classList.add("media-active")
                })), n.update()), BlsZoomThumbsnail.init()), "true" != a && setTimeout((function() {
                    var e = Array.from(t.closest("variant-selects").querySelectorAll(".bls__option-swatch.active"), (e => e.getAttribute("data-value"))),
                        r = JSON.parse(t.closest("variant-selects").querySelector('[type="application/json"]').textContent).find((t => !t.options.map(((t, r) => e[r] === t)).includes(!1)));
                    if (r && r.featured_media) {
                        var i = r.featured_media.id,
                            a = t.closest(".bls__template-product").querySelector(`.product__media-gallery [data-media-id="${i}"]`).getAttribute("data-position");
                        o && o.slideTo(a - 1, 600), c && c.slideTo(a - 1, 600)
                    }
                }), 100)
            }), !1)
        })), o && o.on("slideChange", (function() {
            var e = o.realIndex + 1,
                r = t.querySelector(`.gallery-img[data-position="${e}"]`);
            r?.classList.contains("model") ? o.allowTouchMove = !1 : o.allowTouchMove = !0
        })), c.on("slideChange", (function() {
            var e = c.realIndex + 1,
                t = a.querySelector(`.gallery-img[data-position="${e}"]`);
            t?.classList.contains("model") ? c.allowTouchMove = !1 : c.allowTouchMove = !0
        }))
    }
};
BlsEventMainProductShopify.init();